import React from 'react';
import styles from '../styles/WireframeBackground.module.css';

const WireframeBackground = () => {
    return (
        <div className={styles.container}>
            <svg className={styles.wireframe} viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid slice">
                <defs>
                    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{ stopColor: 'var(--accent-blue)', stopOpacity: 0.1 }} />
                        <stop offset="100%" style={{ stopColor: 'var(--accent-cyan)', stopOpacity: 0.05 }} />
                    </linearGradient>
                </defs>

                {/* 回転する大きなリング */}
                <circle className={`${styles.shape} ${styles.ring1}`} cx="500" cy="500" r="300" />
                <circle className={`${styles.shape} ${styles.ring2}`} cx="500" cy="500" r="400" />

                {/* ポリゴンライン (飾り) */}
                <path className={`${styles.shape} ${styles.poly1}`} d="M500,200 L800,800 L200,800 Z" fill="none" stroke="var(--accent-blue)" strokeWidth="1" strokeOpacity="0.2" />
                <rect className={`${styles.shape} ${styles.rect1}`} x="300" y="300" width="400" height="400" fill="none" stroke="var(--accent-cyan)" strokeWidth="1" strokeOpacity="0.1" />

                {/* ランダムな浮遊パーティクル */}
                <circle className={styles.particle} cx="200" cy="200" r="2" />
                <circle className={styles.particle} cx="800" cy="800" r="3" />
                <circle className={styles.particle} cx="800" cy="200" r="2" />
                <circle className={styles.particle} cx="200" cy="800" r="2" />
            </svg>
        </div>
    );
};

export default WireframeBackground;
